export const job_types = [
  {
    id: 1,
    title: "Full Time",
  },
  {
    id: 2,
    title: "Part Time",
  },
  {
    id: 3,
    title: "WFH",
  },
  {
    id: 4,
    title: "Internship",
  },
];

export const job_type_list = {
  "1": "Full Time",
  "2": "Part Time",
  "3": "WFH",
  "4": "Intership",
};
